const publisherTypes = {
  investmentFirm: 'IF',
  tradingVenue: 'TV'
};

 export default publisherTypes;


// WEBPACK FOOTER //
// ./src/common/constants/publisherTypes.js